let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8UB5T")).then(() => parcelRequire('aGJF2'));